/*
* プロジェクト詳細画面_収益シミュレーション機能
* 計算ロジックは ./calculator.js に分離（純粋関数）し、本クラスは DOM I/O のみを担う
*/

import {
  calculateOperationTermDays,
  calculateStandardSimulation,
  calculateUpfrontFeeSimulation,
  formatYen,
} from './calculator';

export default class Simulation {
  constructor() {
    this.$simulationTrigger = document.querySelectorAll('[data-target="simulationAccordionTrigger"]');
    this.$targetBtn         = document.getElementById('simulation-button');
    this.$simulationContent = document.getElementById('simulation-content');

    this.$capitalAmount     = document.querySelector('[data-target="displayTotalAmount"]');
    this.$afterTax          = document.querySelector('[data-target="afterTax"]');
    this.$beforeTax         = document.querySelector('[data-target="beforeTax"]');
    this.$tax               = document.querySelector('[data-target="tax"]');
    this.$capitalSimAmount  = document.querySelector('[data-target="capitalAmount"]');
    this.$upfrontFee        = document.querySelector('[data-target="upfrontFee"]');
    this.$interest          = document.querySelector('[data-target="interestRate"]');

    this.$numberBoxStepUp   = document.querySelector('[data-target="numberBoxStepUp"]');
    this.$numberBoxStepDown = document.querySelector('[data-target="numberBoxStepDown"]');
    this.$numberBox         = document.querySelector('[data-target="numberBox"]');

    this.$operationStartDate = document.getElementById('operationStartDate');
    this.$operationEndDate   = document.getElementById('operationEndDate');
  }
  openSimulationAccordion() {
    if(this.$targetBtn == null) {
      return;
    }
    this.$targetBtn.addEventListener('click', () => {
      if(this.$simulationContent.classList.contains('is-open')) {
        this.$simulationContent.classList.remove('is-open');
      } else {
        this.$simulationContent.classList.add('is-open');
      }
    });
  }
  attachEvent() {
    if(this.$simulationTrigger.length == 0) {
      return;
    }
  }
  readCapitalAmount() {
    return Number(this.$capitalAmount.textContent.trim().replace('¥', '').replaceAll(',', ''));
  }
  readProfitRate() {
    // 利益(通常分配金)の計算に使う年利。表示値をそのまま使う
    const parsed = Number(this.$interest.textContent);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  readTaxRate() {
    // 源泉税の課税ベースとなるレート。data-simulation-tax-rate があれば優先し、なければ年利を使う
    const ds = this.$interest.dataset.simulationTaxRate;
    if (ds !== undefined && ds !== '') {
      const parsed = Number(ds);
      if (Number.isFinite(parsed)) return parsed;
    }
    return this.readProfitRate();
  }
  readUpfrontFeeRate() {
    const ds = this.$interest.dataset.upfrontFeeRate;
    if (ds !== undefined && ds !== '') {
      const parsed = Number(ds);
      if (Number.isFinite(parsed)) return parsed;
    }
    return 0;
  }
  isTsonUpfrontFeeSimulation() {
    if (this.$simulationContent == null) {
      return false;
    }
    return this.$simulationContent.dataset.siteShortName === 'tson' && this.$simulationContent.dataset.upfrontFeeEnabled === 'true';
  }
  calculateSimulation() {
    if (this.$afterTax == null) {
      return;
    }
    const capitalAmount     = this.readCapitalAmount();
    const operationTermDays = calculateOperationTermDays(
      this.$operationStartDate.textContent,
      this.$operationEndDate.textContent,
    );
    const taxRate           = this.readTaxRate();

    if (this.isTsonUpfrontFeeSimulation()) {
      const result = calculateUpfrontFeeSimulation({
        capitalAmount,
        upfrontFeeRate: this.readUpfrontFeeRate(),
        grossDistributionRate: taxRate,
        operationTermDays,
      });

      this.$beforeTax.innerText = formatYen(result.beforeTax);
      this.$tax.innerText       = formatYen(result.tax,      { negative: true });
      this.$afterTax.innerText  = formatYen(result.afterTax);
      if (this.$capitalSimAmount != null) {
        this.$capitalSimAmount.innerText = formatYen(result.principal);
      }
      if (this.$upfrontFee != null) {
        this.$upfrontFee.innerText = formatYen(result.upfrontFee, { negative: true });
      }
      return;
    }

    const result = calculateStandardSimulation({
      capitalAmount,
      profitRate: this.readProfitRate(),
      taxRate,
      operationTermDays,
    });

    this.$afterTax.innerText  = formatYen(result.afterTax);
    this.$beforeTax.innerText = formatYen(result.beforeTax);
    this.$tax.innerText       = formatYen(result.tax);
  }
}
